import React from 'react';

import {
	type SearchFilters,
	SearchResultsTab as SearchResultsItemsTabEnum,
} from '../../../../types/search';
import type { Alert } from '../../../NotificationAlert/NotificationAlert';
import CourseMindItemsTab from './CourseMindItemsTab';
import MindItemsTab from './MindItemsTab';
import ProductsTab from './ProductsTab';
import UnifiedItemsTab from './UnifiedItemsTab';
import VideoMindItemsTab from './VideoMindItemsTab';

const searchResultsTabMap = {
	[SearchResultsItemsTabEnum.MINDITEMS]: MindItemsTab,
	[SearchResultsItemsTabEnum.PRODUCTS]: ProductsTab,
	[SearchResultsItemsTabEnum.VIDEOS]: VideoMindItemsTab,
	[SearchResultsItemsTabEnum.COURSES]: CourseMindItemsTab,
	[SearchResultsItemsTabEnum.ALL]: UnifiedItemsTab,
};

export type SearchResultsTabProps = {
	currentTab: SearchResultsItemsTabEnum;
	requestFilters: SearchFilters;
	loadMore: () => void;
	searchEngineVersion: number;
	searchTerm?: string;
	userActionConfig: {
		hideCollectionAction?: boolean;
		hidePinAction?: boolean;
	};
	onShowNotification?: (alert: Alert) => void;
	onRelatedTopicSelect?: (topic: string) => void;
};

const SearchResultsTab = ({
	searchResultsTab,
	...rest
}: {
	searchResultsTab: SearchResultsItemsTabEnum;
} & SearchResultsTabProps) => {
	const TabComponent = searchResultsTabMap[searchResultsTab];
	return <TabComponent {...rest} />;
};

export default SearchResultsTab;
